import {
  GlobalSearchFormattedData,
  GlobalSearchSelectOption,
} from "data/@types/GlobalSearchData";
import { create } from "zustand";

export type State = {
  globalSearchData: GlobalSearchFormattedData[];
  searchTerm: string;
  selectedItem: GlobalSearchSelectOption;
};

export type Actions = {
  updateGlobalSearchData: (
    globalSearchData: GlobalSearchFormattedData[],
  ) => void;
  updatedSearchTerm: (searchTerm: string) => void;
  updateSelectedItem: (item: GlobalSearchSelectOption) => void;
  reset: () => void;
};

export type Store = State & Actions;

const initialState: State = {
  globalSearchData: [
    { name: "Firms", total: 0, content: [], hasOnlyPartialMatches: false },
    {
      name: "Products/Strategies",
      total: 0,
      content: [],
      hasOnlyPartialMatches: false,
    },
    { name: "Comments", total: 0, content: [], hasOnlyPartialMatches: false },
    { name: "Meetings", total: 0, content: [], hasOnlyPartialMatches: false },
    {
      name: "Rating Changes",
      total: 0,
      content: [],
      hasOnlyPartialMatches: false,
    },
    {
      name: "Issue Sheet Updates",
      total: 0,
      content: [],
      hasOnlyPartialMatches: false,
    },
  ],
  searchTerm: "",
  selectedItem: "All",
};

export const useGlobalSearchStore = create<Store>((set) => ({
  ...initialState,
  updateGlobalSearchData: (globalSearchData: GlobalSearchFormattedData[]) => {
    set((state) => ({
      ...state,
      globalSearchData,
    }));
  },
  updatedSearchTerm: (searchTerm: string) => {
    set((state) => ({
      ...state,
      searchTerm,
    }));
  },
  updateSelectedItem: (selectedItem: GlobalSearchSelectOption) => {
    set((state) => ({
      ...state,
      selectedItem,
    }));
  },
  reset: () => set(initialState),
}));
